module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/hero-mobile-32584e26bf8503bc0e2633dee713a829.png";